
import React, { useEffect, useRef } from 'react';
import flvjs from 'flv.js/dist/flv.js';

const FlvPlayer = ({ url }) => {
  const videoRef = useRef(null);
  const flvPlayerRef = useRef(null);

  useEffect(() => {
    // Destroy old player if URL changes
    let retryTimer = null;
    if (flvPlayerRef.current) {
      try {
        flvPlayerRef.current.destroy();
      } catch (e) { }
    }

    if (!url) return;

    const player = flvjs.createPlayer({
      type: 'flv',
      url: url,
      isLive: true,
      enableStashBuffer: true,
      stashInitialSize: 512 * 1024,
      enableWorker: true,
      autoCleanupSourceBuffer: true,
      autoCleanupMaxBackwardDuration: 5,
      autoCleanupMinBackwardDuration: 1
    });

    flvPlayerRef.current = player;

    player.attachMediaElement(videoRef.current);
    player.load();

    player.play().catch(() => { });
    retryTimer = setTimeout(() => {
      if (videoRef.current?.readyState < 2) {
        try {
          player.destroy();
          const newP = flvjs.createPlayer(
            {
              type: 'flv',
              url,
              isLive: true,
              enableStashBuffer: true,
              stashInitialSize: 512 * 1024,
              enableWorker: true,
              enableStashBuffer: true,
              autoCleanupSourceBuffer: true,
              autoCleanupMaxBackwardDuration: 5,
              autoCleanupMinBackwardDuration: 1,
            }
          );
          flvPlayerRef.current = newP;
          newP.attachMediaElement(videoRef.current);
          newP.load();
          newP.play().catch(() => { });
        } catch (err) { }
      }
    }, 2000);


    return () => {
      clearTimeout(retryTimer);
      try { player.destroy(); } catch (e) { }
    };
  }, [url]);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <video
        ref={videoRef}
        controls
        muted
        style={{ width: '100%', height: 200, background: '#000' }}
      />
    </div>
  );
};

export default FlvPlayer;
